import {
  reduxOntologyTypes,
  reduxUserRightsTypes,
  reduxIncidentFolderTypes,
  reduxIncidentTypes,
  reduxTrainingObjectiveTypes,
  reduxInjectionTypes,
  reduxActionTypes,
  reduxObservationTaskTypes,
  reduxStateTypes,
  reduxTransactionTypes,
  reduxOutcomeTypes,
  reduxDeliverableTypes,
  reduxConfigurationChangeRequestTypes,
  reduxTroubleTicketTypes,
  reduxTechnicalSupportRequestTypes,
  reduxExperimentationTypes,
  reduxResourceTypes,
  reduxFieldsTypes,
  reduxLillTypes,
  reduxRegistryTypes,
  reduxSettingTypes,
  reduxActorBookTypes,
  reduxWorkPackageTypes,
  reduxTestTypes,
  reduxBattleRhythmTypes,
  reduxLineOfEffortTypes,
  reduxPlanOrderReportProcessTypes,
  reduxPhaseTypes,
  reduxRiskTypes,
} from 'src/types';
import {
  ACTION_ADDED,
  KANBAN_ADDED,
  INCIDENT_FOLDER_ADDED,
  WORK_PACKAGE_ADDED,
  INCIDENT_ADDED,
  TASK_ADDED,
  INCIDENT_EDITED,
  TASK_EDITED,
  INJECTION_ADDED,
  PROJECTINPUT_ADDED,
  OBSERVATION_TASK_ADDED,
  TEST_ADDED,
  STATE_ADDED,
  TRANSACTION_ADDED,
  ONTOLOGY_ADDED,
  TRAINING_OBJECTIVE_ADDED,
  OUTCOME_ADDED,
  DELIVERABLE_ADDED,
  ONTOLOGIES_SET,
  LILL_SET,
  LILL_ADDED,
  LILL_DELETED,
  LILL_EDITED,
  USER_RIGHTS_SET,
  INCIDENT_FOLDERS_SET,
  WORK_PACKAGES_SET,
  INCIDENTS_SET,
  TASKS_SET,
  TRAINING_OBJECTIVES_SET,
  INJECTIONS_SET,
  PROJECTINPUTS_SET,
  ACTIONS_SET,
  KANBANS_SET,
  OBSERVATION_TASKS_SET,
  TESTS_SET,
  STATE_SET,
  TRANSACTION_SET,
  OUTCOMES_SET,
  DELIVERABLES_SET,
  CONFIGURATION_CHANGE_REQUEST_SET,
  CONFIGURATION_CHANGE_REQUEST_ADDED,
  TROUBLE_TICKET_ADDED,
  USER_RIGHTS_ADDED,
  EXPERIMENTATION_SET,
  EXPERIMENTATION_ADDED,
  EXPERIMENTATION_STATUS_UPDATE,
  EXPERIMENTATION_REPORT_SET,
  RESOURCE_ADDED,
  RESOURCE_SET,
  TRAINING_OBJECTIVE_EDITED,
  INCIDENT_FOLDER_EDITED,
  WORK_PACKAGE_EDITED,
  INJECTION_EDITED,
  PROJECTINPUT_EDITED,
  ACTION_EDITED,
  KANBAN_EDITED,
  OUTCOME_EDITED,
  DELIVERABLE_EDITED,
  OBSERVATION_TASK_EDITED,
  TEST_EDITED,
  USER_RIGHTS_EDITED,
  CONFIGURATION_CHANGE_REQUEST_EDITED,
  TROUBLE_TICKET_EDITED,
  TROUBLE_TICKET_SET,
  INCIDENT_FOLDER_DELETED,
  WORK_PACKAGE_DELETED,
  INCIDENT_DELETED,
  TASK_DELETED,
  INJECTION_DELETED,
  PROJECTINPUT_DELETED,
  ACTION_DELETED,
  KANBAN_DELETED,
  OUTCOME_DELETED,
  DELIVERABLE_DELETED,
  OBSERVATION_TASK_DELETED,
  TEST_DELETED,
  TRAINING_OBJECTIVE_DELETED,
  CONFIGURATION_CHANGE_REQUEST_DELETED,
  TROUBLE_TICKET_DELETED,
  FIELDS_SET,
  FIELD_ADD,
  TRANSACTION_DELETED,
  STATE_DELETED,
  TRANSACTION_EDITED,
  ONTOLOGY_EDITED,
  TECHNICAL_SUPPORT_REQUEST_SET,
  TECHNICAL_SUPPORT_REQUEST_ADDED,
  TECHNICAL_SUPPORT_REQUEST_EDITED,
  TECHNICAL_SUPPORT_REQUEST_DELETED,
  ONTOLOGY_DELETED,
  ONTOLOGIES_DELETED,
  STATE_EDITED,
  REGISTRY_SET,
  REGISTRY_ADDED,
  REGISTRY_DELETED,
  REGISTRY_EDITED,
  SETTING_SET,
  SETTING_ADDED,
  SETTING_DELETED,
  SETTING_EDITED,
  PARAMETER_SET,
  PARAMETER_EDITED,
  ROAD_TO_CURRENT_SETTINGS_SET,
  ROAD_TO_CURRENT_SETTINGS_ADDED,
  ROAD_TO_CURRENT_SETTINGS_UPDATED,
  ROAD_TO_CURRENT_SETTINGS_DELETED,
  EXPERIMENTATION_DELETED,
  BATTLE_RHYTHMS_SET,
  BATTLE_RHYTHM_ADDED,
  BATTLE_RHYTHM_EDITED,
  BATTLE_RHYTHM_DELETED,
  EFFECT_SET,
  EFFECT_ADDED,
  EFFECT_EDITED,
  EFFECT_DELETED,
  TURNCHART_SET,
  TURNCHART_ADDED,
  TURNCHART_EDITED,
  TURNCHART_DELETED,
  OD_TASK_SET,
  OD_TASK_ADDED,
  OD_TASK_EDITED,
  OD_TASK_DELETED,
  LINE_OF_EFFORT_SET,
  LINE_OF_EFFORT_ADDED,
  PLAN_ORDER_REPORT_PROCESS_SET,
  PLAN_ORDER_REPORT_PROCESS_ADDED,
  DECISIVE_CONDITION_ADDED,
  DECISIVE_CONDITION_DELETED,
  DECISIVE_CONDITION_EDITED,
  DECISIVE_CONDITION_SET,
  LINE_OF_EFFORT_EDITED,
  LINE_OF_EFFORT_DELETED,
  PLAN_ORDER_REPORT_PROCESS_DELETED,
  PLAN_ORDER_REPORT_PROCESS_EDITED,
  PHASE_SET,
  PHASE_ADDED,
  PHASE_DELETED,
  PHASE_EDITED,
  PROJECTS_SET,
  PROJECT_ADDED,
  PROJECT_EDITED,
  PROJECT_DELETED,
  COA_SET,
  COA_ADDED,
  COA_EDITED,
  COA_DELETED,
  RISK_SET,
  RISK_ADDED,
  RISK_EDITED,
  RISK_DELETED,
} from 'src/app/redux/redux-types';
import {
  IncidentCreateResultType,
  IncidentEditResultType,
  IncidentResultType,
  IncidentTableResultType,
} from 'src/types/services/incident-service.type';
import { LillCreateResultType, LillEditResultType, LillResultType } from 'src/types/services/lill-service.type';
import {
  InjectionEditResultType,
  InjectionResultType,
  InjectionTableResultType,
} from 'src/types/services/injection-service.type';
import {
  TrainingObjectiveEditResultType,
  TrainingObjectiveResultType,
  TrainingObjectiveTableResultType,
} from 'src/types/services/objective-service.type';
import {
  IncidentFolderEditResultType,
  IncidentFolderResultType,
} from 'src/types/services/incident-folder-service.type';
import { ActionEditResultType, ActionResultType, ActionTableResultType } from 'src/types/services/action-service.type';
import { OutcomeEditResultType, OutcomeTableResultType } from 'src/types/services/outcome-service.type';
import {
  ObservationTaskEditResultType,
  ObservationTaskTableResultType,
} from 'src/types/services/observation-task-service.type';
import {
  UserRightsCreateResultType,
  UserRightsEditResultType,
  UserRightsResultType,
} from 'src/types/services/user-rights-service.type';
import { ConfigurationChangeRequestEditResultType } from 'src/types/services/configuration-change-request-service.type';
import { TroubleTicketEditResultType, TroubleTicketResultType } from 'src/types/services/trouble-ticket-service.type';
import { OntologyEditResultType, OntologyResultType } from 'src/types/services/ontology-service.type';
import { StateResultType } from 'src/types/services/state-service.type';
import { TransactionEditResultType } from 'src/types/services/transaction-service.type';
import { TechnicalSupportRequestEditResultType } from 'src/types/services/technical-support-request.service.type';
import { RegistryEditResultType, RegistryResultType } from 'src/types/services/registry-service.type';
import { SettingEditResultType, SettingResultType } from 'src/types/services/setting-service.type';
import { ParameterEditResultType, ParameterResultType } from 'src/types/services/actorbook-service.type';
import { RoadToCurrentSetting } from 'src/types/services/road-to-current-settings-service.type';
import { StatusEnum } from 'src/enums/experimentation.enum';
import { WorkPackageEditResultType } from 'src/types/services/ppm/work-package-service.type';

import {
  ProjectInputEditResultType,
  ProjectInputResultType,
  ProjectInputTableResultType,
} from 'src/types/services/ppm/project-input-service.type';
import {
  KanbanCreateResultType,
  KanbanEditResultType,
  KanbanTableResultType,
} from 'src/types/services/ppm/kanban-service.type';
import { DeliverableEditResultType } from 'src/types/services/ppm/deliverable-service.type';
import { TestEditResultType } from 'src/types/services/ppm/test-service.type';
import { BattleRhythmEditResultType } from 'src/types/services/battle-rhythm-service.type';
import {
  EffectDataType,
  EffectCreateResultType,
  EffectEditResultType,
} from 'src/types/services/odc2m/effect-service.type';

import {
  TaskCreateResultType,
  TaskEditResultType,
  TaskTableResultType,
} from 'src/types/services/ppm/task-service.type';
import {
  TaskCreateResultType as ODTaskCreateResultType,
  TaskResultType,
  TaskDeleteDataType as ODTaskDeleteDataType,
  TaskEditResultType as ODTaskEditResultType,
} from 'src/types/services/odc2m/od-task-service.type';
import {
  DecisiveCondition,
  DecisiveConditionCreateDataType,
  DecisiveConditionCreateResultType,
  DecisiveConditionEditResultType,
  DecisiveConditionResultType,
} from 'src/types/services/odc2m/decisive-condition-service.type';
import {
  TurnChartCreateDataType,
  TurnChartDataType,
  TurnChartEditDataType,
} from 'src/types/services/odc2m/turn-chart-service.type';
import { ProjectCreateResultType, ProjectEditResultType } from 'src/types/services/ppm/project-service.type';
import { CoaCreateResultType, CoaEditResultType } from 'src/types/services/coam/coa.service.type';
import { RiskCreateResultType, RiskEditResultType } from 'src/types/services/coam/risk.service.type';
export const ontologyList = (list: OntologyResultType[]) => {
  return {
    type: ONTOLOGIES_SET,
    payload: list,
  };
};

export const userRightsList = (list: UserRightsResultType[]) => {
  return {
    type: USER_RIGHTS_SET,
    payload: list,
  };
};

// export const eventList = (list: reduxEventTypes.EventInformation[]) => {
//   return {
//     type: EVENTS_SET,
//     payload: list,
//   };
// };

export const incidentFolderList = (list: reduxIncidentFolderTypes.IncidentFolderInformation[]) => {
  return {
    type: INCIDENT_FOLDERS_SET,
    payload: list,
  };
};

export const workPackageList = (list: reduxWorkPackageTypes.WorkPackageInformation[]) => {
  return {
    type: WORK_PACKAGES_SET,
    payload: list,
  };
};

export const incidentFolderDelete = (payload: string) => {
  return {
    type: INCIDENT_FOLDER_DELETED,
    payload,
  };
};

export const workPackageDelete = (payload: string) => {
  return {
    type: WORK_PACKAGE_DELETED,
    payload,
  };
};

export const lillList = (list: LillResultType[]) => {
  return {
    type: LILL_SET,
    payload: list,
  };
};

export const incidentList = (list: IncidentTableResultType[]) => {
  return {
    type: INCIDENTS_SET,
    payload: list,
  };
};

export const taskList = (list: TaskTableResultType[]) => {
  return {
    type: TASKS_SET,
    payload: list,
  };
};

export const incidentDelete = (payload: string) => {
  return {
    type: INCIDENT_DELETED,
    payload,
  };
};

export const projectInputDelete = (payload: string) => {
  return {
    type: PROJECTINPUT_DELETED,
    payload,
  };
};

export const taskDelete = (payload: string) => {
  return {
    type: TASK_DELETED,
    payload,
  };
};

export const trainingObjectiveList = (list: TrainingObjectiveTableResultType[]) => {
  return {
    type: TRAINING_OBJECTIVES_SET,
    payload: list,
  };
};
export const trainingObjectiveDelete = (payload: string) => {
  return {
    type: TRAINING_OBJECTIVE_DELETED,
    payload,
  };
};

export const injectionList = (list: InjectionTableResultType[]) => {
  return {
    type: INJECTIONS_SET,
    payload: list,
  };
};

export const projectInputList = (list: ProjectInputTableResultType[]) => {
  return {
    type: PROJECTINPUTS_SET,
    payload: list,
  };
};

export const injectionDelete = (payload: string) => {
  return {
    type: INJECTION_DELETED,
    payload,
  };
};

export const actionList = (list: ActionTableResultType[]) => {
  return {
    type: ACTIONS_SET,
    payload: list,
  };
};

export const kanbanList = (list: KanbanTableResultType[]) => {
  return {
    type: KANBANS_SET,
    payload: list,
  };
};

export const actionDelete = (payload: string) => {
  return {
    type: ACTION_DELETED,
    payload,
  };
};

export const kanbanDelete = (payload: string) => {
  return {
    type: KANBAN_DELETED,
    payload,
  };
};

export const outcomeList = (list: reduxOutcomeTypes.OutcomeInformation[]) => {
  return {
    type: OUTCOMES_SET,
    payload: list,
  };
};

export const deliverableList = (list: reduxDeliverableTypes.DeliverableInformation[]) => {
  return {
    type: DELIVERABLES_SET,
    payload: list,
  };
};

export const outcomeDelete = (payload: string) => {
  return {
    type: OUTCOME_DELETED,
    payload,
  };
};

export const deliverableDelete = (payload: string) => {
  return {
    type: DELIVERABLE_DELETED,
    payload,
  };
};

export const observationTaskList = (list: reduxObservationTaskTypes.ObservationTaskInformation[]) => {
  return {
    type: OBSERVATION_TASKS_SET,
    payload: list,
  };
};

export const testList = (list: reduxTestTypes.TestInformation[]) => {
  return {
    type: TESTS_SET,
    payload: list,
  };
};

export const observationTaskDelete = (payload: string) => {
  return {
    type: OBSERVATION_TASK_DELETED,
    payload,
  };
};

export const testDelete = (payload: string) => {
  return {
    type: TEST_DELETED,
    payload,
  };
};

export const stateList = (list: reduxStateTypes.StateInformation[]) => {
  return {
    type: STATE_SET,
    payload: list,
  };
};
export const transactionList = (list: reduxTransactionTypes.TransactionInformation[]) => {
  return {
    type: TRANSACTION_SET,
    payload: list,
  };
};

export const configurationChangeRequestList = (
  list: reduxConfigurationChangeRequestTypes.ConfigurationChangeRequestInformation[],
  isCCRFetchRequestCompleted = true,
) => {
  return {
    type: CONFIGURATION_CHANGE_REQUEST_SET,
    payload: {
      list,
      isCCRFetchRequestCompleted,
    },
  };
};

export const troubleTicketList = (
  list: reduxTroubleTicketTypes.TroubleTicketInformation[],
  isTTFetchRequestCompleted = true,
) => {
  return {
    type: TROUBLE_TICKET_SET,
    payload: {
      list,
      isTTFetchRequestCompleted,
    },
  };
};
export const registryList = (list: RegistryResultType[]) => {
  return {
    type: REGISTRY_SET,
    payload: list,
  };
};
export const parameterList = (list: reduxActorBookTypes.ParameterInformation[]) => {
  return {
    type: PARAMETER_SET,
    payload: list,
  };
};

export const settingList = (list: SettingResultType[]) => {
  return {
    type: SETTING_SET,
    payload: list,
  };
};

export const technicalSupportRequestList = (
  list: reduxTechnicalSupportRequestTypes.TechnicalSupportRequestInformation[],
  isTSRFetchRequestCompleted = true,
) => {
  return {
    type: TECHNICAL_SUPPORT_REQUEST_SET,
    payload: {
      list,
      isTSRFetchRequestCompleted,
    },
  };
};

export const experimentationList = (list: reduxExperimentationTypes.ExperimentationInformation[]) => {
  return {
    type: EXPERIMENTATION_SET,
    payload: list,
  };
};

export const deleteExperimentation = (payload: string) => {
  return {
    type: EXPERIMENTATION_DELETED,
    payload,
  };
};

export const resourceList = (list: reduxResourceTypes.ResourceInformation[]) => {
  return {
    type: RESOURCE_SET,
    payload: list,
  };
};

// export const statesList = (list: reduxStateTypes.StateInformation[]) => {
//   return {
//     type: STATE_SET,
//     payload: list,
//   };
// };

export const fieldsList = (list: reduxFieldsTypes.FieldInformation[]) => {
  return {
    type: FIELDS_SET,
    payload: list,
  };
};

export const phaseList = (list: reduxPhaseTypes.PhaseInformation[]) => {
  return {
    type: PHASE_SET,
    payload: list,
  };
};

export const phaseAdded = (list: reduxPhaseTypes.PhaseInformation) => {
  return {
    type: PHASE_ADDED,
    payload: list,
  };
};

export const phaseEdited = (list: reduxPhaseTypes.PhaseInformation) => {
  return {
    type: PHASE_EDITED,
    payload: list,
  };
};

export const phaseDeleted = (id: string) => {
  return {
    type: PHASE_DELETED,
    payload: id,
  };
};

export const lineOfEffortList = (list: reduxLineOfEffortTypes.LineOfEffortInformation[]) => {
  return {
    type: LINE_OF_EFFORT_SET,
    payload: list,
  };
};

export const lineOfEffortAdded = (list: reduxLineOfEffortTypes.LineOfEffortInformation) => {
  return {
    type: LINE_OF_EFFORT_ADDED,
    payload: list,
  };
};

export const lineOfEffortEdited = (list: reduxLineOfEffortTypes.LineOfEffortInformation) => {
  return {
    type: LINE_OF_EFFORT_EDITED,
    payload: list,
  };
};

export const lineOfEffortDeleted = (id: string) => {
  return {
    type: LINE_OF_EFFORT_DELETED,
    payload: id,
  };
};
export const planOrderReportProcessList = (
  list: reduxPlanOrderReportProcessTypes.PlanOrderReportProcessInformation[],
) => {
  return {
    type: PLAN_ORDER_REPORT_PROCESS_SET,
    payload: list,
  };
};

export const planOrderReportProcessAdded = (
  payload: reduxPlanOrderReportProcessTypes.PlanOrderReportProcessInformation,
) => {
  return {
    type: PLAN_ORDER_REPORT_PROCESS_ADDED,
    payload,
  };
};
export const planOrderReportProcessEdited = (
  payload: reduxPlanOrderReportProcessTypes.PlanOrderReportProcessInformation,
) => {
  return {
    type: PLAN_ORDER_REPORT_PROCESS_EDITED,
    payload,
  };
};
export const planOrderReportProcessDeleted = (payload: string) => {
  return {
    type: PLAN_ORDER_REPORT_PROCESS_DELETED,
    payload,
  };
};
// export const eventAdded = (payload: EventResultType) => {
//   return {
//     type: EVENT_ADDED,
//     payload,
//   };
// };

export const fieldListAdd = (payload: reduxFieldsTypes.FieldInformation) => {
  return {
    type: FIELD_ADD,
    payload,
  };
};

export const incidentEdited = (payload: IncidentEditResultType) => {
  return {
    type: INCIDENT_EDITED,
    payload,
  };
};

export const taskEdited = (payload: TaskEditResultType) => {
  return {
    type: TASK_EDITED,
    payload,
  };
};

export const incidentAdded = (payload: IncidentCreateResultType) => {
  return {
    type: INCIDENT_ADDED,
    payload,
  };
};

export const taskAdded = (payload: TaskCreateResultType) => {
  return {
    type: TASK_ADDED,
    payload,
  };
};

export const injectionAdded = (payload: InjectionResultType) => {
  return {
    type: INJECTION_ADDED,
    payload,
  };
};

export const projectInputAdded = (payload: ProjectInputResultType) => {
  return {
    type: PROJECTINPUT_ADDED,
    payload,
  };
};

export const injectionEdited = (payload: InjectionEditResultType) => {
  return {
    type: INJECTION_EDITED,
    payload,
  };
};

export const projectInputEdited = (payload: ProjectInputEditResultType) => {
  return {
    type: PROJECTINPUT_EDITED,
    payload,
  };
};

export const actionAdded = (payload: ActionResultType) => {
  return {
    type: ACTION_ADDED,
    payload,
  };
};

export const kanbanAdded = (payload: KanbanCreateResultType) => {
  return {
    type: KANBAN_ADDED,
    payload,
  };
};

export const actionEdited = (payload: ActionEditResultType) => {
  return {
    type: ACTION_EDITED,
    payload,
  };
};

export const kanbanEdited = (payload: KanbanEditResultType) => {
  return {
    type: KANBAN_EDITED,
    payload,
  };
};

export const outcomeAdded = (payload: reduxOutcomeTypes.OutcomeInformation) => {
  return {
    type: OUTCOME_ADDED,
    payload,
  };
};

export const deliverableAdded = (payload: reduxDeliverableTypes.DeliverableInformation) => {
  return {
    type: DELIVERABLE_ADDED,
    payload,
  };
};

export const outcomeEdited = (payload: OutcomeEditResultType) => {
  return {
    type: OUTCOME_EDITED,
    payload,
  };
};

export const deliverableEdited = (payload: DeliverableEditResultType) => {
  return {
    type: DELIVERABLE_EDITED,
    payload,
  };
};

export const observationTaskAdded = (payload: reduxObservationTaskTypes.ObservationTaskInformation) => {
  return {
    type: OBSERVATION_TASK_ADDED,
    payload,
  };
};

export const testAdded = (payload: reduxTestTypes.TestInformation) => {
  return {
    type: TEST_ADDED,
    payload,
  };
};

export const observationTaskEdited = (payload: ObservationTaskEditResultType) => {
  return {
    type: OBSERVATION_TASK_EDITED,
    payload,
  };
};

export const testEdited = (payload: TestEditResultType) => {
  return {
    type: TEST_EDITED,
    payload,
  };
};

export const stateAdded = (payload: StateResultType) => {
  return {
    type: STATE_ADDED,
    payload,
  };
};

export const stateEdited = (payload: StateResultType) => {
  return {
    type: STATE_EDITED,
    payload,
  };
};

export const transactionAdded = (payload: reduxTransactionTypes.TransactionInformation) => {
  return {
    type: TRANSACTION_ADDED,
    payload,
  };
};
export const transactionEdited = (payload: TransactionEditResultType) => {
  return {
    type: TRANSACTION_EDITED,
    payload,
  };
};

export const lillAdded = (payload: LillCreateResultType) => {
  return {
    type: LILL_ADDED,
    payload,
  };
};

export const stateDelete = (payload: string) => {
  return {
    type: STATE_DELETED,
    payload,
  };
};
export const transactionDelete = (payload: string) => {
  return {
    type: TRANSACTION_DELETED,
    payload,
  };
};
export const lillDelete = (payload: string) => {
  return {
    type: LILL_DELETED,
    payload,
  };
};
export const trainingObjectiveEdited = (payload: TrainingObjectiveEditResultType) => {
  return {
    type: TRAINING_OBJECTIVE_EDITED,
    payload,
  };
};
export const trainingObjectiveAdded = (payload: reduxTrainingObjectiveTypes.TrainingObjectiveInformation) => {
  return {
    type: TRAINING_OBJECTIVE_ADDED,
    payload,
  };
};

export const configurationChangeRequestAdded = (
  payload: reduxConfigurationChangeRequestTypes.ConfigurationChangeRequestInformation,
) => {
  return {
    type: CONFIGURATION_CHANGE_REQUEST_ADDED,
    payload,
  };
};

export const technicalSupportRequestAdded = (
  payload: reduxTechnicalSupportRequestTypes.TechnicalSupportRequestInformation,
) => {
  return {
    type: TECHNICAL_SUPPORT_REQUEST_ADDED,
    payload,
  };
};

export const lillEdited = (payload: LillEditResultType) => {
  return {
    type: LILL_EDITED,
    payload,
  };
};

export const configurationChangeRequestEdited = (payload: ConfigurationChangeRequestEditResultType) => {
  return {
    type: CONFIGURATION_CHANGE_REQUEST_EDITED,
    payload,
  };
};

export const technicalSupportRequestEdited = (payload: TechnicalSupportRequestEditResultType) => {
  return {
    type: TECHNICAL_SUPPORT_REQUEST_EDITED,
    payload,
  };
};

export const configurationChangeRequestDelete = (payload: string) => {
  return {
    type: CONFIGURATION_CHANGE_REQUEST_DELETED,
    payload,
  };
};

export const technicalSupportRequestDeleted = (payload: string) => {
  return {
    type: TECHNICAL_SUPPORT_REQUEST_DELETED,
    payload,
  };
};

export const troubleTicketAdded = (payload: reduxTroubleTicketTypes.TroubleTicketInformation) => {
  return {
    type: TROUBLE_TICKET_ADDED,
    payload,
  };
};

export const troubleTicketEdited = (payload: TroubleTicketEditResultType) => {
  return {
    type: TROUBLE_TICKET_EDITED,
    payload,
  };
};
export const troubleTicketDelete = (payload: string) => {
  return {
    type: TROUBLE_TICKET_DELETED,
    payload,
  };
};
export const registryAdded = (payload: reduxRegistryTypes.RegistryInformation) => {
  return {
    type: REGISTRY_ADDED,
    payload,
  };
};
export const registryDelete = (payload: string) => {
  return {
    type: REGISTRY_DELETED,
    payload,
  };
};
export const registryEdited = (payload: RegistryEditResultType) => {
  return {
    type: REGISTRY_EDITED,
    payload,
  };
};
export const parameterEdited = (payload: any) => {
  return {
    type: PARAMETER_EDITED,
    payload,
  };
};

export const settingAdded = (payload: reduxSettingTypes.SettingInformation) => {
  return {
    type: SETTING_ADDED,
    payload,
  };
};

export const settingDelete = (payload: string) => {
  return {
    type: SETTING_DELETED,
    payload,
  };
};

export const settingEdited = (payload: SettingEditResultType) => {
  return {
    type: SETTING_EDITED,
    payload,
  };
};

export const incidentFolderAdded = (payload: reduxIncidentFolderTypes.IncidentFolderInformation) => {
  return {
    type: INCIDENT_FOLDER_ADDED,
    payload,
  };
};

export const workPackageAdded = (payload: reduxWorkPackageTypes.WorkPackageInformation) => {
  return {
    type: WORK_PACKAGE_ADDED,
    payload,
  };
};

export const incidentFolderEdited = (payload: IncidentFolderEditResultType) => {
  return {
    type: INCIDENT_FOLDER_EDITED,
    payload,
  };
};

export const workPackageEdited = (payload: WorkPackageEditResultType) => {
  return {
    type: WORK_PACKAGE_EDITED,
    payload,
  };
};

export const ontologyAdded = (payload: reduxOntologyTypes.OntologyInformation) => {
  return {
    type: ONTOLOGY_ADDED,
    payload,
  };
};

export const ontologyEdited = (payload: OntologyEditResultType) => {
  return {
    type: ONTOLOGY_EDITED,
    payload,
  };
};

export const ontologyDeleted = (payload: string) => {
  return {
    type: ONTOLOGY_DELETED,
    payload,
  };
};

export const ontologiesDeleted = (payload: string[]) => {
  return {
    type: ONTOLOGIES_DELETED,
    payload,
  };
};

export const userRightsAdded = (payload: UserRightsCreateResultType) => {
  return {
    type: USER_RIGHTS_ADDED,
    payload,
  };
};
export const userRightsEdited = (payload: UserRightsEditResultType) => {
  return {
    type: USER_RIGHTS_EDITED,
    payload,
  };
};

export const experimentationAdded = (list: reduxExperimentationTypes.ExperimentationInformation) => {
  return {
    type: EXPERIMENTATION_ADDED,
    payload: list,
  };
};

export const updateExperimentationStatus = (id: string, status: StatusEnum) => ({
  type: EXPERIMENTATION_STATUS_UPDATE,
  payload: { id, status },
});

export const resourceAdded = (list: reduxResourceTypes.ResourceInformation) => {
  return {
    type: RESOURCE_ADDED,
    payload: list,
  };
};

export const experimentationReportSet = (
  data: reduxExperimentationTypes.ExperimentationReport | reduxExperimentationTypes.ExperimentationErrorReport,
) => {
  return {
    type: EXPERIMENTATION_REPORT_SET,
    payload: data,
  };
};
// export const userAdded = (payload: reduxUserTypes.UserListInformation) => {
//   return {
//     type: USERS_ADDED,
//     payload,
//   };
// };

export const roadToCurrentSettingsList = (list: RoadToCurrentSetting[]) => {
  return {
    type: ROAD_TO_CURRENT_SETTINGS_SET,
    payload: list,
  };
};

export const roadToCurrentSettingsAdded = (payload: RoadToCurrentSetting) => {
  return {
    type: ROAD_TO_CURRENT_SETTINGS_ADDED,
    payload,
  };
};

export const roadToCurrentSettingsUpdated = (payload: RoadToCurrentSetting) => {
  return {
    type: ROAD_TO_CURRENT_SETTINGS_UPDATED,
    payload,
  };
};

export const roadToCurrentSettingsDeleted = (payload: string) => {
  return {
    type: ROAD_TO_CURRENT_SETTINGS_DELETED,
    payload,
  };
};

export const battleRhythmList = (list: reduxBattleRhythmTypes.BattleRhythmInformation[]) => {
  return {
    type: BATTLE_RHYTHMS_SET,
    payload: list,
  };
};

export const battleRhythmAdded = (payload: reduxBattleRhythmTypes.BattleRhythmInformation) => {
  return {
    type: BATTLE_RHYTHM_ADDED,
    payload,
  };
};

export const battleRhythmEdited = (payload: BattleRhythmEditResultType) => {
  return {
    type: BATTLE_RHYTHM_EDITED,
    payload,
  };
};

export const battleRhythmDeleted = (payload: string) => {
  return {
    type: BATTLE_RHYTHM_DELETED,
    payload,
  };
};

export const effectList = (list: EffectDataType[]) => {
  return {
    type: EFFECT_SET,
    payload: list,
  };
};

export const effectAdded = (payload: EffectCreateResultType) => {
  return {
    type: EFFECT_ADDED,
    payload,
  };
};

export const effectEdited = (payload: EffectEditResultType) => {
  return {
    type: EFFECT_EDITED,
    payload,
  };
};

export const effectDeleted = (payload: string) => {
  return {
    type: EFFECT_DELETED,
    payload,
  };
};

export const turnChartList = (list: TurnChartDataType[]) => {
  return {
    type: TURNCHART_SET,
    payload: list,
  };
};

export const turnChartAdded = (payload: TurnChartCreateDataType) => {
  return {
    type: TURNCHART_ADDED,
    payload,
  };
};

export const turnChartEdited = (payload: TurnChartEditDataType[]) => {
  return {
    type: TURNCHART_EDITED,
    payload,
  };
};

export const turnChartDeleted = (payload: string) => {
  return {
    type: TURNCHART_DELETED,
    payload,
  };
};

export const odTaskList = (list: TaskResultType[]) => {
  return {
    type: OD_TASK_SET,
    payload: list,
  };
};

export const odTaskAdded = (payload: ODTaskCreateResultType) => {
  return {
    type: OD_TASK_ADDED,
    payload,
  };
};

export const odTaskEdited = (payload: ODTaskEditResultType) => {
  return {
    type: OD_TASK_EDITED,
    payload,
  };
};

export const odTaskDeleted = (payload: ODTaskDeleteDataType) => {
  return {
    type: OD_TASK_DELETED,
    payload,
  };
};

export const decisiveConditionList = (list: DecisiveConditionResultType[]) => {
  return {
    type: DECISIVE_CONDITION_SET,
    payload: list,
  };
};

export const decisiveConditionAdded = (payload: DecisiveConditionCreateResultType) => {
  return {
    type: DECISIVE_CONDITION_ADDED,
    payload,
  };
};

export const decisiveConditionEdited = (payload: DecisiveConditionEditResultType) => {
  return {
    type: DECISIVE_CONDITION_EDITED,
    payload,
  };
};

export const decisiveConditionDeleted = (payload: string) => {
  return {
    type: DECISIVE_CONDITION_DELETED,
    payload,
  };
};

export const projectsList = (list: ProjectCreateResultType[]) => {
  return {
    type: PROJECTS_SET,
    payload: list,
  };
};

export const projectAdded = (payload: ProjectCreateResultType) => {
  return {
    type: PROJECT_ADDED,
    payload,
  };
};

export const projectEdited = (payload: ProjectEditResultType) => {
  return {
    type: PROJECT_EDITED,
    payload,
  };
};

export const projectDeleted = (payload: string) => {
  return {
    type: PROJECT_DELETED,
    payload,
  };
};

export const coaList = (list: CoaCreateResultType[]) => {
  return {
    type: COA_SET,
    payload: list,
  };
};

export const coaAdded = (payload: CoaCreateResultType) => {
  return {
    type: COA_ADDED,
    payload,
  };
};

export const coaEdited = (payload: CoaEditResultType) => {
  return {
    type: COA_EDITED,
    payload,
  };
};

export const coaDeleted = (payload: string) => {
  return {
    type: COA_DELETED,
    payload,
  };
};

export const riskList = (list: RiskCreateResultType[]) => {
  return {
    type: RISK_SET,
    payload: list,
  };
};

export const riskAdded = (payload: RiskCreateResultType) => {
  return {
    type: RISK_ADDED,
    payload,
  };
};

export const riskEdited = (payload: RiskEditResultType) => {
  return {
    type: RISK_EDITED,
    payload,
  };
};

export const riskDeleted = (payload: string) => {
  return {
    type: RISK_DELETED,
    payload,
  };
};
